var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"rackman-image",attrs:{"src":`img/icons/${_vm.image}`,"height":"30px","width":"30px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }